import React, { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { CustomModal } from "components/modals/ModalBox";
import { addArticleCategoryApi, articleCategoryDetailApi, updateArticleCategoryApi } from "services/article";

const formTeething = {
    GUMS: "Gum",
    BITE: "Biting",
}

const ManageActivity = ({ _id, type, onClose, isOpen, getListHandler }) => {
    const isEditable = useMemo(() => type === "EDIT", [type]);
    const [formFields, setFormFields] = useState({
        uploadedImage: null,
        image: "",
        name: "",
    });

    const fetchData = async () => {
        try {
            const { data } = await articleCategoryDetailApi({ _id });
            if (data?.success) {
                const detail = data?.data;
                setFormFields(prev => ({
                    ...prev,
                    name: detail?.name,
                }));
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (isEditable) {
            fetchData();
        }

        return () => {
            setFormFields({
                uploadedImage: null,
                image: "",
                name: ""
            });
        }
    }, [isOpen]);

    // onChangeHandler
    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        if (name === "number") {
            const numericValue = value.replace(/\D/g, "");
            setFormFields({ ...formFields, number: numericValue });
        } else {
            setFormFields({ ...formFields, [name]: value });
        }
    };

    // Error Handler
    const errorHandler = () => {
        let isValid = true;

        if (!formFields?.name) {
            isValid = false;
            toast.error("Please Enter Name");
            return;
        }


        if (!formFields?.uploadedImage && !isEditable) {
            isValid = false;
            toast.error("Please Upload Image");
            return;
        }

        return isValid;
    };

    const createRequest = async () => {
        if (errorHandler()) {
            try {
                const formData = new FormData();
                const payload = {
                    ...formFields,
                    image: formFields?.uploadedImage,
                }

                delete payload?.uploadedImage;

                for (const key in payload) {
                    if (key === "teething" || key === "motorSkills" || key === "speech" || key === "ageGroup") {
                        formData.append(key, JSON.stringify(payload[key]));
                    } else {
                        formData.append(key, payload[key]);
                    }
                }

                const { data } = await addArticleCategoryApi(formData);
                if (data?.success) {
                    toast.success(data?.message);
                    onClose();
                    getListHandler();
                } else {
                    toast.error(data?.message);
                }
            } catch (err) {
                console.error(err);
            }
        }
    };

    const updateRequest = async (e) => {
        if (errorHandler()) {
            try {
                const formData = new FormData();
                const payload = {
                    ...formFields,
                    ...(formFields?.uploadedImage && { image: formFields?.uploadedImage })
                }

                delete payload?.uploadedImage;
                if (payload?.image?.length === 0) {
                    delete payload?.image;
                }

                for (const key in payload) {
                    formData.append(key, payload[key]);
                }

                formData.append("_id", _id);
                const { data } = await updateArticleCategoryApi(formData);
                if (data?.success) {
                    toast.success(data?.message);
                    onClose();
                    getListHandler();
                } else {
                    toast.error(data?.message);
                }
            } catch (err) {
                console.error(err);
            }
        }
    };

    // onSubmitHandler
    const onSubmitHandler = async (e) => {
        e.preventDefault();
        console.log({ type });

        if (type === "CREATE") {
            createRequest();
        } else {
            updateRequest();
        }
    };

    return (
        <CustomModal className={"lg"} show={isOpen} handleClose={onClose}>
            <div className="personal_details_parents" style={{ padding: 0 }}>
                <div className="personal_form_wrap">
                    <h4>{isEditable ? "Update" : "Create"} Article Category</h4>

                    <button
                        className="button"
                        onClick={(e) => onSubmitHandler(e)}
                    >
                        {isEditable ? "Update" : "Create"}
                    </button>
                </div>

                <form>
                    <div className="form_field_wrap choose_file">
                        <div className="form_field ">
                            <label htmlFor="fname" className="label">
                                Image *
                            </label>
                            <input
                                type="file"
                                name="name"
                                className="input"
                                onChange={e => setFormFields(rev => ({ ...rev, uploadedImage: e.target.files[0] }))}
                            />
                        </div>

                        <div className="form_field">
                            <label htmlFor="fname" className="label">
                                Name *
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="input"
                                onChange={onChangeHandler}
                                value={formFields?.name}
                            />
                        </div>
                    </div>

                </form>

                <div className="form_border_bottom"></div>
            </div>
        </CustomModal>
    );
};

export default ManageActivity;
